<div class="container-fluid no-padding">
    <div class="home-section bg1">
        <div class="row m-0" >
            <div class="col-12" style="color: white;">

              <div class="d-none d-lg-block">
                <h1 style="color: #749549; max-width: 90%;">Competencies of Professional
                    Psychology Rating Scales (COPPR)</h1>
                <hr>
                <h2 style="text-align: left; font-size: 26pt !important;" class="rubik-medium">
                    Reflect on your professional competencies.
                </h2>
                <h2 style="text-align: left; font-size: 26pt !important;" class="rubik-medium">
                    Track your development.
                </h2>
                <h2 style="text-align: left; font-size: 26pt !important;" class="rubik-medium">
                  Guide your growth.
                </h2>
                <p class="text2" style="margin-top: 40px; margin-bottom: 30px; font-size: 21pt; max-width: 90%;">
                    The Competencies of Professional Psychology Rating Scales (COPPR) are
                    standardised inventories designed to help psychologists and trainees reflect on
                    and assess their professional competencies across multiple domains of practice.
                </p>
              </div>

              <div class="d-block d-lg-none">
                  <h1 style="color: #749549; font-size: 30pt !important;">Competencies of Professional
                    Psychology Rating Scales (COPPR)</h1>
                <hr>
                <h2 style="text-align: left; font-size: 20pt !important;" class="rubik-medium">
                    Reflect on your professional competencies.
                </h2>
                <h2 style="text-align: left; font-size: 20pt !important;" class="rubik-medium">
                    Track your development.
                </h2>
                <h2 style="text-align: left; font-size: 20pt !important;" class="rubik-medium">
                  Guide your growth.
                </h2>
                <p class="text2" style="margin-top: 40px; margin-bottom: 30px; font-size: 18pt; max-width: 90%;">
                    The Competencies of Professional Psychology Rating Scales (COPPR) are
                    standardised inventories designed to help psychologists and trainees reflect on
                    and assess their professional competencies across multiple domains of practice.
                </p>
              </div>

                


                <p style="max-width: 90%;" class="p-light">
                    Whether you’re a university trainee, placement student, intern, registrar, or experienced practitioner, the COPPR
                    Scales provide a meaningful framework for understanding your strengths and identifying areas for strategic
                    development. The COPPR Scales also support placement evaluation for training pathways.
                </p>
                <p style="max-width: 90%;" class="p-light">
                    With the addition of a clinical subscale, the COPPR Scales now support all registered psychologists – whether in
                    professional or clinical psychology practice and training.
                </p>
            </div>
        </div>
    </div>

    <div class="home-section" style="background-color: #FBF9F4; text-align: center;">
      <div class="row m-0" >
        <h2 class="alt-h" style="margin-bottom: 80px; margin-top: 20px;">What are the COPPR Scales?</h2>
        <div class="col-12 col-lg-6">
          <div class="flexv2">
            <div style="padding: 0px 15px; text-align: center;" class="d-block d-lg-none">
              <img src="assets/images/coppr1.png" style="max-height: 50vh; min-height: 300px; max-width: 100%;">
            </div>
            <div style="padding: 0px 15px;" class="d-none d-lg-block">
              <img src="assets/images/coppr1.png" style="width: 100%; min-height: 300px;">
            </div>
          </div>
          
          
        </div>
        <div class="col-12 col-lg-6">
          <div class="flexv">
            <p class="largetext">The COPPR Scales were developed
                by Dr Kylie Rice (University of New
                England) and colleagues to guide
                psychologists in reflecting on their
                competencies.</p>
              <p class="text2">The scales feature both a self-report version for
                psychologists and trainees to complete on their
                own competencies, and an observer version for
                supervisors to complete for their supervisees. This
                dual perspective approach enables a comprehensive,
                360-degree view of professional capability.</p>
                <p class="text2">
                    The COPPR Scales allow psychologists, trainees,
                    and supervisors to reflect upon, assess, and monitor
                    competence development across multiple domains
                    of practice, which can then guide professional
                    development and supervision.
                </p>
          </div>
         
        </div>
      </div>
    </div>
  
    <div class="home-section" style="background-color: #EAEEF4; text-align: center;">
      <h2 class="alt-h" style="margin-bottom: 40px; margin-top: 20px;">Why use the COPPR Scales?</h2>
      <div style="max-width: 75vw; margin: auto;">
        <div class="row" style="padding: 20px;">
          <div class="col-12 col-md-6" style="padding: 20px;">
            <div class="box">
              <img src="/assets/images/Icon_10.svg" alt="">
              <h4>Dual perspective assessment:</h4>
              <p>Complete a self-report version to reflect
                  on your own competencies, or ask your
                  supervisor to complete an observer version
                  for a 360-degree view of your development.</p>
            </div>
          </div>
          <div class="col-12 col-md-6" style="padding: 20px;">
            <div class="box">
              <img src="/assets/images/Icon_11.svg" alt="">
              <h4>Track development over time:</h4>
              <p>Complete the COPPR Scales as often as
                  you like and monitor your competency
                  development across your career trajectory.</p>
            </div>
          </div>
          <div class="col-12 col-md-6" style="padding: 20px;">
              <div class="box">
                <img src="/assets/images/Icon_12.svg" alt="">
                <h4>Guide meaningful supervision and review:</h4>
                <p>Use your results to structure conversations
                  with your supervisor, inform your placement
                  review, or guide your professional
                  development planning.</p>
              </div>
            </div>
            <div class="col-12 col-md-6" style="padding: 20px;">
              <div class="box">
                <img src="/assets/images/Icon_13.svg" alt="">
                <h4>Comprehensive across career stages:</h4>
                <p>The COPPR Scales are designed for all
                  stages of your psychology career, from
                  training through to experienced practice.</p>
              </div>
            </div>
        </div>
        </div>
      
    </div>

    <div class="home-section bg2" style="text-align: center;">
        <h2 class="alt-h" style="margin-bottom: 40px; margin-top: 20px; color: #b9d989;">How to use the COPPR Scales</h2>
        <div style="max-width: 75vw; margin: auto;">
          <div class="row" style="padding: 20px;">
            <div class="col-12 col-md-6" style="padding: 20px;">
            <div class="box">
              <img src="/assets/images/Icon_14.svg" alt="">
              <h4>Reflect:</h4>
              <p>Complete the self-report version to
                assess your current competencies across
                multiple domains of practice.</p>
            </div>
          </div>
          <div class="col-12 col-md-6" style="padding: 20px;">
            <div class="box">
              <img src="/assets/images/Icon_15.svg" alt="">
              <h4>Gain perspective:</h4>
              <p>Optionally ask your supervisor to complete
                the observer version for additional insight.</p>
            </div>
          </div>
          <div class="col-12 col-md-6" style="padding: 20px;">
              <div class="box">
                <img src="/assets/images/Icon_16.svg" alt="">
                <h4>Track progress:</h4>
                <p>Return to the COPPR Scales periodically to
                    monitor your development over time.</p>
              </div>
            </div>
            <div class="col-12 col-md-6" style="padding: 20px;">
              <div class="box">
                <img src="/assets/images/Icon_17.svg" alt="">
                <h4>Take action:</h4>
                <p>Use your results to inform your professional
                    development planning, supervision
                    conversations, and placement review.</p>
              </div>
            </div>
          </div>
       </div>
    </div>

    <div class="home-section" style="background-color: #FBF9F4;">
        <div class="row" style="margin: 0px 0px 80px 0px;">
            <div class="col-12">
              <div >
                <h2 class="alt-h" style="margin-bottom: 40px; margin-top: 20px;">For Practitioners</h2>
              </div>
                
            </div>
          
          
          <div class="col-12 col-lg-6">
            <div class="flexv" style="padding-left: 0;">
              <p class="largetext rubik-light">The COPPR Scales offer a
                meaningful framework for reflecting
                on your professional competencies
                and guiding your career
                development at any stage of
                your psychology career.</p>
                <p class="text2">Gain clarity on your strengths and development
                    priorities, track your competency growth across
                    your career trajectory, and use your results to inform
                    professional development decisions with confidence
                    and strategic direction.</p>
                  <p class="text2">
                    Whether you’re building evidence of your
                    development for your professional portfolio,
                    enhancing supervision conversations, or simply
                    reflecting on your practice, the COPPR Scales
                    support meaningful self-reflection grounded in
                    current professional standards.
                  </p>
            </div>
           
          </div>
          <div class="col-12 col-lg-6">
            <div class="flexv2">
              <div style="padding: 0px 15px; text-align: center;" class="d-block d-lg-none">
                <img src="assets/images/coppr2.png" style="max-height: 50vh; min-height: 300px; max-width: 100%; margin-top: 30px;">
              </div>
              <div style="padding: 0px 15px;" class="d-none d-lg-block">
                <img src="assets/images/coppr2.png" style="width: 100%; min-height: 300px;">
              </div>
            </div>
            
          </div>
        </div>

        <hr>

        <div class="row m-0">
          <div class="col-12">
            <div >
              <h2 class="alt-h" style="margin-bottom: 80px; margin-top: 20px;">For Placement Coordinators, Supervisors, and Universities</h2>
            </div>
              
          </div>
          <div class="col-12 col-lg-6">
            <div class="flexv2">
              <div style="padding: 0px 40px; text-align: center;" class="d-block d-lg-none">
                <img src="assets/images/coppr3.png" style="max-height: 50vh; min-height: 300px; max-width: 100%;">
              </div>
              <div style="padding: 0px 40px 0px 0px;" class="d-none d-lg-block">
                <img src="assets/images/coppr3.png" style="width: 100%; min-height: 300px;">
              </div>
            </div>
            
          </div>
          <div class="col-12 col-lg-6">
            <div class="flexv">
              <p class="largetext rubik-light">The COPPR Scales offer a
                standardised, evidence-based
                approach to competency evaluation
                and development within your training
                and placement programs.</p>
                <p class="text2">Embed meaningful competency reflection into your
                  placement pathways using the dual self-report
                  and observer versions to structure evaluation on
                  competency domains. Track student and trainee
                  development over time, align your evaluations with
                  Psychology Board of Australia competencies and
                  APAC Standards, and strengthen the quality of
                  learning outcomes and professional readiness across
                  your organisation.</p>
                 
            </div>
           
          </div>

        </div>        
      </div>

      <div class="home-section bg2" style="text-align: center; padding-bottom: 100px;">
        <h2 class="alt-h" style="margin-bottom: 40px; margin-top: 20px; color: #b9d989;">What's new in the COPPR Scales</h2>
        <div style="max-width: 75vw; margin: auto;">
          <div class="row" style="padding: 20px;">
            <div class="col-12 col-md-6" style="padding: 20px;">
            <div class="box">
              <div class="rubik-light" style="margin-bottom: 20px; font-size: 21pt;">COPPR 2.0: Updated for
                Current Standards!</div>
              <h4>Aligned with current standards</h4>
              <p>COPPR 2.0 reflects the latest Psychology Board of Australia
                competencies and updated APAC Standards, ensuring
                relevance and credibility across Australian practice contexts.</p>
            </div>
          </div>
          <div class="col-12 col-md-6" style="padding: 20px;">
            <div class="box">
              <div class="rubik-light" style="margin-bottom: 20px; font-size: 21pt;">New release of a validated
                Clinical subscale for the COPPR!</div>
              <h4>Clinical pathway option</h4>
              <p>A new clinical subscale enables COPPR 2.0 to be applied
                across clinical training pathways, aligned with APAC Level
                4 Clinical endorsement competencies. This makes COPPR
                2.0 beneficial for both professional and clinical psychology
                training courses in Australia.</p>
            </div>
          </div>
          

          </div>
       </div>
    </div>
  
    <div class="home-section" style="padding-bottom: 30px;">
      <div class="row m-0" style="padding: 20px 30px;">
        <div class="col-12 col-lg-4" style="border-left: 1px solid; padding-left: 40px;">
          <img src="assets/images/logo2.png" class="flogo" style="margin-left: -13px; padding: 5px 0px;">
          <p class="rubik-medium" style="font-size: 11pt;">For inquiries or collaborations, please <a routerLink="/contact-us" routerLinkActive="active" style="color: unset;">Contact Us.</a></p>
          <address class="rubik-light" style="font-size: 11pt;">
            Associate Professor Kylie Rice<br>
            Executive Director, Thrive Research Centre<br><br>
            
            Faculty of Medicine and Health<br>   
            University of New England<br><br>
            
          </address>
        </div>
        <div class="col-12 col-lg-4" style="border-left: 1px solid; padding-left: 40px;">
          <img src="assets/images/UNE_Logo.png" class="flogo">
          <p class="rubik-medium" style="font-size: 11pt;">Research by:</p>
          <address class="rubik-light" style="font-size: 11pt;">
            University of New England<br>
            Armidale NSW 2351 Australia<br><br>
            <a class="rubik-medium" href="https://une.edu.au" target="_blank" style="color: unset;">une.edu.au</a>
          </address>
        </div>
        <div class="col-12 col-lg-4" style="border-left: 1px solid; padding-left: 40px;">
          <img src="assets/images/UNE_CASI_Logo.png" class="flogo">
          <p class="rubik-medium" style="font-size: 11pt;">Dashboard developed by:</p>
          <address class="rubik-light" style="font-size: 11pt;">
            UNE CASI (Computation, Analytics,
            Software, Informatics)<br>
            University of New England<br>
            Armidale NSW 2351 Australia<br><br>
            <a class="rubik-medium" href="https://casi.une.edu.au" target="_blank" style="color: unset;">casi.une.edu.au</a>
          </address>
        </div>
      </div>
      
    </div>
    
    
    
    
  </div>

